import React, {forwardRef} from 'react';
import cn from 'classnames';
import styles from './FieldSelect.css';

const sizeTypeStyles = {
	medium: styles.sizeCompact,
	large: styles.sizeMedium,
};

type NativeSelectProps = React.DetailedHTMLProps<React.SelectHTMLAttributes<HTMLSelectElement>, HTMLSelectElement>;

export interface FieldSelectProps extends NativeSelectProps {
	options: string[];
	getDisplayValue(value: string): string;
	sizeType?: 'medium' | 'large';
}

export const FieldSelect = forwardRef<HTMLSelectElement, FieldSelectProps>((props, ref) => {
	const {className, options, getDisplayValue, sizeType = 'medium', ...nativeProps} = props;

	return (
		<div className={cn(styles.root, className)}>
			<select ref={ref} className={cn(styles.field, sizeType && sizeTypeStyles[sizeType])} {...nativeProps}>
				{options.map(value => (
					<option key={value} value={value}>
						{getDisplayValue(value)}
					</option>
				))}
			</select>
		</div>
	);
});

FieldSelect.displayName = 'FieldSelect';
